import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'
import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

import { useNineGridBox } from 'modules/competencies/lib/ninegridboxContext'

import BlankSlate from './BlankSlate'
import Body from './Body'
import Grid from './Grid'

const Report = () => {
  const { data, form, loading, loadingSetup } = useNineGridBox()
  const ref = React.useRef(null)

  if (loading || loadingSetup) return <Loading />

  if (form.get('x_axis_ids').value.length === 0 || form.get('y_axis_ids').value.length === 0)
    return <BlankSlate />

  const xAxisName =
    form.get('x_axis_name').value || i18n.t('competencies_v2.ninebox.form.x_axis_placeholder')
  const yAxisName =
    form.get('y_axis_name').value || i18n.t('competencies_v2.ninebox.form.y_axis_placeholder')

  return (
    <>
      <Box>
        <Grid data={data} xAxisName={xAxisName} yAxisName={yAxisName} />
      </Box>
      <Box padding="s48">
        <Table fullWidth>
          <Table.Head>
            <Table.Row>
              <Table.HeadCell colSpan={4}>
                {i18n.t('competencies_v2.ninebox.employee')}
              </Table.HeadCell>
              <Table.HeadCell colSpan={2}>
                <OverflowContextProvider childrenRef={ref} value={xAxisName}>
                  <Text.Normal
                    size="200"
                    weight="semibold"
                    ellipsis={xAxisName.length > 11}
                    innerRef={ref}
                  >
                    {xAxisName}
                  </Text.Normal>
                </OverflowContextProvider>
              </Table.HeadCell>
              <Table.HeadCell colSpan={2}>
                <OverflowContextProvider childrenRef={ref} value={yAxisName}>
                  <Text.Normal
                    size="200"
                    weight="semibold"
                    ellipsis={yAxisName.length > 9}
                    innerRef={ref}
                  >
                    {yAxisName}
                  </Text.Normal>
                </OverflowContextProvider>
              </Table.HeadCell>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {data.map((d) => (
              <Body key={d.accessId} xAxis={d.xAxis} yAxis={d.yAxis} userId={d.accessId} />
            ))}
          </Table.Body>
        </Table>
      </Box>
    </>
  )
}

export default observer(Report)
